<template>
	<RadioGroup
		v-model:value="action"
		:options="actionOptions"
		option-type="button"
		button-style="solid"
	/>
</template>

<script>
import { computed } from 'vue';
import { RadioGroup } from 'ant-design-vue';

import { useI18n } from 'vue-i18n';

import { useModelProxy } from '@/utils/useModelProxy';

import { ACTIONS } from '@/components/tariffs/Consts';

export default {
	components: {
		RadioGroup,
	},
	emits: ['update:modelValue'],
	props: ['modelValue'],
	setup(props, { emit }) {
		const { t } = useI18n();
		const action = useModelProxy(props, emit);
		const actionOptions = computed(() => ACTIONS.map(value => ({
			value,
			label: t('tariffs.tariffActions.' + value),
		})));
		return {
			action,
			actionOptions,
		};
	},
}
</script>
